import { setNotificationSettings } from './actions';
import NotificationSettingsService from './NotificationSettingsService';
import { sessionUserSelector } from '../session';

const fetchNotificationSettingsAsync = () => (dispatch, getState) => {
  const state = getState();
  const user = sessionUserSelector(state);

  return dispatch(NotificationSettingsService.getByUserId(user.id)).then(
    notificationSettings =>
      dispatch(setNotificationSettings(notificationSettings)),
  );
};

const saveNotificationSettingsAsync = notificationSettings => (
  dispatch,
  getState,
) => {
  const state = getState();
  const user = sessionUserSelector(state);

  const request = {
    settings: notificationSettings,
    userId: user.id,
  };

  return dispatch(NotificationSettingsService.create(request)).then(
    dispatch(setNotificationSettings(notificationSettings)),
  );
};

export { fetchNotificationSettingsAsync, saveNotificationSettingsAsync };



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationSettings/thunks.js